const showLang = ['zh_TW', 'VN', 'TH', 'en_US'];
export default showLang;
